import { render, staticRenderFns } from "./project_create.vue?vue&type=template&id=64272e68&scoped=true"
import script from "./project_create.vue?vue&type=script&lang=js"
export * from "./project_create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64272e68",
  null
  
)

export default component.exports